import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { EnvironmentConfig } from '../../interfaces/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class InvoiceOperationService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;
  private readonly _reportServiceBaseUrl =
    this._env.environment.pureSpectrum.reportServiceUrl;
  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  downloadFile(fileName: string, token: string | null) {
    return `${this._baseUrl}/reports/download-report/${fileName}?access_token=${token}`;
  }

  downloadSTRV3(
    cmp: number,
    survey_id: string | undefined,
    user_type: string,
    includeTestTransactions: boolean = false
  ) {
    return this._http.get<{ fileName: string }>(
      `${this._baseUrl}/reports/surveys/traffic-report?user_id=${cmp}&survey_id=${survey_id}&type=${user_type}&includeTestTransactions=${includeTestTransactions}`
    );
  }

  downloadCSTransactionReport(surveyId: number | undefined) {
    return this._http.get<{ fileName: string }>(
      `${this._reportServiceBaseUrl}/survey/${surveyId}/download-report`
    );
  }

  downloadFileCSTransactionReport(surveyId: number | undefined) {
    return `${this._reportServiceBaseUrl}/survey/${surveyId}`;
  }

  downloadSupplierSummaryReport(surveyId: number | undefined) {
    return this._http.get<{ fileName: string }>(
      `${this._reportServiceBaseUrl}/survey/${surveyId}/generate/supplier-summary`
    );
  }

  downloadFileSupplierSummaryReport(surveyId: number | undefined) {
    return `${this._reportServiceBaseUrl}/survey/${surveyId}/download/supplier-summary`;
  }
}
